import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'pseic-section',
  templateUrl: './pseic-section.component.html',
  styleUrls: ['./pseic-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PseicSectionComponent {

  @Input() sectionTitle = '';
  @Input() doubleSection = false;
  @Input() foldable? = false;
  @Input() defaultFold? = false;
  @Input() showTitle? = true;

  handleTitleClick(): void {
    if (this.foldable) {
      this.defaultFold = !this.defaultFold
    }
  }
}
